// @ts-check
import React, { FC } from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import cx from 'classnames';
import classes from './StatusBadge.module.scss';

/** @typedef {{
  statusSymbol: string,
  statusName: string
}} StatusBadgePropsType */

/** @type { React.ValidationMap<StatusBadgePropsType> } */
const propTypes = {
  statusSymbol: PropTypes.string.isRequired,
  statusName: PropTypes.string.isRequired,
};

/** @type { FC<StatusBadgePropsType> } */
const StatusBadge = ({ statusSymbol, statusName }) => (
  <span className={cx(classes.badge, classes[statusSymbol])}>
    <span className={classes.label}>{statusName}</span>
  </span>
);

StatusBadge.propTypes = propTypes;

export default StatusBadge;
